import { useMemo } from "react";
import useGetExpandedDetailsLocal from "../../samples/hooks/useGetExpandedDetailsLocal";
import { useMwpDetectionsData } from "../../samples_cloud/hooks";
import { ReferenceState } from "../DifferenceMatrixReference";
import {
  matrixValuesFromDetails,
  matrixValuesFromDetections
} from "../differenceMatrixFields";

const useMatrixReference = (
  sha1: string | undefined,
  sourceId?: number,
  relationshipId?: number
) => {
  const { data, isLoading } = useGetExpandedDetailsLocal(
    sha1,
    sourceId,
    relationshipId
  );
  const { data: detections } = useMwpDetectionsData(sha1 ?? "");
  const reference = useMemo(
    () =>
      data
        ? {
            ...matrixValuesFromDetails(data),
            ...matrixValuesFromDetections(detections)
          }
        : undefined,
    [data, detections]
  );
  // Not loading and no data means the fetch failed or came back empty; either
  // way there is nothing to compare against.
  const state: ReferenceState = reference
    ? { status: "ready", values: reference }
    : { status: isLoading ? "loading" : "error" };

  return { state, mainFileName: data?.source?.filename };
};

export default useMatrixReference;
